// extracted by mini-css-extract-plugin
export const className = "Player--aLqVj";